<template>
  <div class="mention-dropdown-menu">
    <template v-if="items.length && items[0] !== ''">
      <button
        :class="{ 'is-selected': index === selectedIndex }"
        v-for="(item, index) in items"
        :key="index"
        @click="selectItem(index)">
        @{{ item.username }} {{ getDisplayName(item) }}
      </button>
    </template>
    <div class="item" v-else>No result</div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
  command: {
    type: Function,
    required: true,
  },
});

const selectedIndex = ref(0);

watch(
  () => props.items,
  () => {
    selectedIndex.value = 0;
  },
);

const getDisplayName = user => {
  if (!user) return '';
  const firstName = user.firstName || '';
  const lastName = user.lastName || '';
  if (firstName || lastName) {
    return `| ${firstName} ${lastName}`.trim();
  }
  return '';
};

const upHandler = () => {
  selectedIndex.value = (selectedIndex.value + props.items.length - 1) % props.items.length;
};

const downHandler = () => {
  selectedIndex.value = (selectedIndex.value + 1) % props.items.length;
};

const selectItem = index => {
  const item = props.items[index];
  if (item) {
    props.command({ id: item });
  }
};

const enterHandler = () => {
  selectItem(selectedIndex.value);
};

const onKeyDown = ({ event }) => {
  if (event.key === 'ArrowUp') {
    upHandler();
    return true;
  }

  if (event.key === 'ArrowDown') {
    downHandler();
    return true;
  }

  if (event.key === 'Enter') {
    enterHandler();
    return true;
  }

  return false;
};

// Экспортируем onKeyDown для использования в родительском компоненте
defineExpose({
  onKeyDown,
});
</script>

<style lang="scss">
.mention-dropdown-menu {
  background: var(--background-secondary) !important;
  border: 1px solid var(--background-primary) !important;
  border-radius: 0.7rem;
  box-shadow: var(--background-primary) !important;
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  overflow: auto;
  padding: 0.5rem;
  position: relative;

  button {
    align-items: center;
    background-color: transparent;
    display: flex;
    gap: 0.25rem;
    text-align: left;
    width: 100%;

    &:hover,
    &:hover.is-selected {
      background-color: transparent !important;
      color: #a78bfa !important;
    }

    &.is-selected {
      background-color: transparent !important;
      color: #a78bfa !important;
    }
  }
}
</style>
